import {
	useState,
	useEffect,
	useRef
} from "react";
import {
	Navigate,
	useParams,
	useNavigate
} from "react-router-dom";
import {
	Box,
	Typography,
	Container,
	Grid,
	Paper,
	Skeleton,
	IconButton,
	TextField,
	FormGroup,
	FormControlLabel,
	Checkbox,
	TableContainer,
	Table,
	TableBody,
	TableRow,
	TableCell,
	TableHead,
	TableSortLabel,
	Button,
	Tooltip,
} from '@mui/material';
import {
	LoadingButton
} from '@mui/lab'
import ClientService from '../../services/ClientService'
import _ from 'underscore'
import ClientProfileComponent from '../../components/client/ClientProfile'
import ClientNote from '../../components/client/profile/ClientNote'
import ClientProfileClass from '../../components/client/profile/ClientProfileClass'
import ClientLocation from '../../components/client/profile/ClientLocation'
import ClientUser from '../../components/client/profile/ClientUser'
import ClientTags from "../../components/client/profile/ClientTags";

const jss = {
	detailSection: {
		py: 2
	},
}


function ClientProfile(props) {
	let { client_code } = useParams()
	const [client, setClient] = useState()
	const navigate = useNavigate()

	useEffect(() => {
		loadClient()
	}, [client_code])

	async function loadClient() {
		try {
			const _client = await ClientService.getClientByCode(client_code)
			setClient(_client)
		} catch(e) {
			navigate('/')
		}
	}

	return <Grid container spacing={2} sx={jss.detailSection}>
		<Grid item xs={12} sm={6}>
			<ClientProfileComponent client={client} onSave={e => setClient(e)} />
		</Grid>
		<Grid item xs={12} sm={6}>
			<Box sx={{mb:2}}>
				<ClientNote client={client}/>
			</Box>
			<Box sx={{mb:2}}>
				<ClientTags client={client}/>
			</Box>
			<Box sx={{mb:2}}>
				<ClientProfileClass client={client}/>
			</Box>
			<Box sx={{mb:2}}>
				<ClientLocation client={client}/>
			</Box>
			<Box sx={{mb:2}}>
				<ClientUser client={client}/>
			</Box>
		</Grid>
	</Grid>
}
export default ClientProfile